module.exports = {
  id: 35,
  name: 'Jump Squats',
  categories: ['cardio', 'strength', 'legs', 'explosiveness'],
  sports: [
    'baseball',
    'basketball',
    'boxing',
    'cricket',
    'dance',
    'football',
    'golf',
    'hockey',
    'lacrosse',
    'martial-arts',
    'gymnastics',
    'rugby',
    'soccer',
    'swimming',
    'tennis',
    'track',
    'volleyball',
  ],
  difficulty: 'advanced',
  skill: 'Power',
  points: 22,
  instructions:
    'Jump squats are explosive! Squat down like you are sitting in a chair, then explode up and jump as high as you can! Land softly like a ninja and repeat. This builds incredible leg power and jumping ability! Ready to jump like a champion?',
  timedInstructions: [
    // SETUP
    {
      time: 2,
      text: 'Ready to jump like a champion?',
    },
    {
      time: 5,
      text: "Let's get explosive and powerful!",
    },
    {
      time: 8,
      text: '3, 2, 1, START JUMPING!',
    },
    // SET 1 - 10 reps
    {
      time: 11,
      text: 'Bend your knees and squat down low, keep your chest up!',
    },
    {
      time: 13,
      text: 'Explode up and jump as high as you can, arms reaching for the sky!',
    },
    {
      time: 15,
      text: 'Land softly on your feet, bend your knees to absorb the impact!',
    },
    {
      time: 17,
      text: 'Bend your knees and squat down low, like sitting in a chair!',
    },
    {
      time: 19,
      text: 'Explode up and jump higher, push through your toes!',
    },
    {
      time: 21,
      text: 'Land softly like a ninja, keep your balance!',
    },
    {
      time: 23,
      text: 'Bend your knees and squat down low, keep your back straight!',
    },
    {
      time: 25,
      text: 'Explode up and jump to the sky, reach for the stars!',
    },
    {
      time: 27,
      text: 'Land softly on your feet, absorb the landing!',
    },
    {
      time: 29,
      text: 'Bend your knees and squat down low, keep your chest up!',
    },
    {
      time: 31,
      text: 'Explode up and jump like a rocket, maximum power!',
    },
    {
      time: 33,
      text: 'Land softly like a ninja, stay balanced!',
    },
    {
      time: 35,
      text: 'Bend your knees and squat down low, keep your form!',
    },
    {
      time: 37,
      text: 'Explode up and jump to the moon, incredible power!',
    },
    {
      time: 39,
      text: 'Land softly on your feet, great landing!',
    },
    {
      time: 41,
      text: 'Bend your knees and squat down low, keep going strong!',
    },
    {
      time: 43,
      text: 'Explode up and jump higher, you are getting stronger!',
    },
    {
      time: 45,
      text: 'Land softly like a ninja, perfect form!',
    },
    {
      time: 47,
      text: 'Bend your knees and squat down low, almost there!',
    },
    {
      time: 49,
      text: 'Explode up and jump to the stars, incredible power!',
    },
    {
      time: 51,
      text: 'Land softly on your feet, amazing jumping!',
    },
    {
      time: 53,
      text: 'Bend your knees and squat down low, last one of this set!',
    },
    {
      time: 55,
      text: 'Explode up and jump your highest, finish strong!',
    },
    {
      time: 57,
      text: 'Land softly like a ninja, incredible first set!',
    },
    // REST PERIOD 1 - 27 seconds
    {
      time: 60,
      text: 'Take a deep breath in and out, you are doing amazing!',
    },
    {
      time: 63,
      text: 'Shake out your legs, get ready for round two!',
    },
    {
      time: 66,
      text: 'Remember to land softly and keep your form!',
    },
    {
      time: 69,
      text: 'You are building incredible jumping power!',
    },
    {
      time: 72,
      text: 'Ready for set two? Let us go!',
    },
    {
      time: 75,
      text: '3, 2, 1, START JUMPING AGAIN!',
    },
    // SET 2 - 10 reps
    {
      time: 78,
      text: 'Bend your knees and squat down low, keep your chest up!',
    },
    {
      time: 80,
      text: 'Explode up and jump as high as you can, arms reaching for the sky!',
    },
    {
      time: 82,
      text: 'Land softly on your feet, bend your knees to absorb the impact!',
    },
    {
      time: 84,
      text: 'Bend your knees and squat down low, like sitting in a chair!',
    },
    {
      time: 86,
      text: 'Explode up and jump higher, push through your toes!',
    },
    {
      time: 88,
      text: 'Land softly like a ninja, keep your balance!',
    },
    {
      time: 90,
      text: 'Bend your knees and squat down low, keep your back straight!',
    },
    {
      time: 92,
      text: 'Explode up and jump to the sky, reach for the stars!',
    },
    {
      time: 94,
      text: 'Land softly on your feet, absorb the landing!',
    },
    {
      time: 96,
      text: 'Bend your knees and squat down low, keep your chest up!',
    },
    {
      time: 98,
      text: 'Explode up and jump like a rocket, maximum power!',
    },
    {
      time: 100,
      text: 'Land softly like a ninja, stay balanced!',
    },
    {
      time: 102,
      text: 'Bend your knees and squat down low, keep your form!',
    },
    {
      time: 104,
      text: 'Explode up and jump to the moon, incredible power!',
    },
    {
      time: 106,
      text: 'Land softly on your feet, great landing!',
    },
    {
      time: 108,
      text: 'Bend your knees and squat down low, keep going strong!',
    },
    {
      time: 110,
      text: 'Explode up and jump higher, you are getting stronger!',
    },
    {
      time: 112,
      text: 'Land softly like a ninja, perfect form!',
    },
    {
      time: 114,
      text: 'Bend your knees and squat down low, almost there!',
    },
    {
      time: 116,
      text: 'Explode up and jump to the stars, incredible power!',
    },
    {
      time: 118,
      text: 'Land softly on your feet, amazing jumping!',
    },
    {
      time: 120,
      text: 'Bend your knees and squat down low, last one of this set!',
    },
    {
      time: 122,
      text: 'Explode up and jump your highest, finish strong!',
    },
    {
      time: 124,
      text: 'Land softly like a ninja, incredible second set!',
    },
    // REST PERIOD 2 - 27 seconds
    {
      time: 127,
      text: 'Take a deep breath in and out, you are halfway there!',
    },
    {
      time: 130,
      text: 'Shake out your legs, get ready for round three!',
    },
    {
      time: 133,
      text: 'Remember to land softly and keep your form!',
    },
    {
      time: 136,
      text: 'You are building incredible jumping power!',
    },
    {
      time: 139,
      text: 'Ready for set three? Let us go!',
    },
    {
      time: 142,
      text: '3, 2, 1, START JUMPING AGAIN!',
    },
    // SET 3 - 10 reps
    {
      time: 145,
      text: 'Bend your knees and squat down low, keep your chest up!',
    },
    {
      time: 147,
      text: 'Explode up and jump as high as you can, arms reaching for the sky!',
    },
    {
      time: 149,
      text: 'Land softly on your feet, bend your knees to absorb the impact!',
    },
    {
      time: 151,
      text: 'Bend your knees and squat down low, like sitting in a chair!',
    },
    {
      time: 153,
      text: 'Explode up and jump higher, push through your toes!',
    },
    {
      time: 155,
      text: 'Land softly like a ninja, keep your balance!',
    },
    {
      time: 157,
      text: 'Bend your knees and squat down low, keep your back straight!',
    },
    {
      time: 159,
      text: 'Explode up and jump to the sky, reach for the stars!',
    },
    {
      time: 161,
      text: 'Land softly on your feet, absorb the landing!',
    },
    {
      time: 163,
      text: 'Bend your knees and squat down low, keep your chest up!',
    },
    {
      time: 165,
      text: 'Explode up and jump like a rocket, maximum power!',
    },
    {
      time: 167,
      text: 'Land softly like a ninja, stay balanced!',
    },
    {
      time: 169,
      text: 'Bend your knees and squat down low, keep your form!',
    },
    {
      time: 171,
      text: 'Explode up and jump to the moon, incredible power!',
    },
    {
      time: 173,
      text: 'Land softly on your feet, great landing!',
    },
    {
      time: 175,
      text: 'Bend your knees and squat down low, keep going strong!',
    },
    {
      time: 177,
      text: 'Explode up and jump higher, you are getting stronger!',
    },
    {
      time: 179,
      text: 'Land softly like a ninja, perfect form!',
    },
    {
      time: 181,
      text: 'Bend your knees and squat down low, almost there!',
    },
    {
      time: 183,
      text: 'Explode up and jump to the stars, incredible power!',
    },
    {
      time: 185,
      text: 'Land softly on your feet, amazing jumping!',
    },
    {
      time: 187,
      text: 'Bend your knees and squat down low, last one of this set!',
    },
    {
      time: 189,
      text: 'Explode up and jump your highest, finish strong!',
    },
    {
      time: 191,
      text: 'Land softly like a ninja, incredible third set!',
    },
    // REST PERIOD 3 - 27 seconds
    {
      time: 194,
      text: 'Take a deep breath in and out, almost done!',
    },
    {
      time: 197,
      text: 'Shake out your legs, get ready for the final round!',
    },
    {
      time: 200,
      text: 'Remember to land softly and keep your form!',
    },
    {
      time: 203,
      text: 'You are building incredible jumping power!',
    },
    {
      time: 206,
      text: 'Ready for the final set? Let us finish strong!',
    },
    {
      time: 209,
      text: '3, 2, 1, START THE FINAL SET!',
    },
    // SET 4 - 10 reps
    {
      time: 212,
      text: 'Bend your knees and squat down low, keep your chest up!',
    },
    {
      time: 214,
      text: 'Explode up and jump as high as you can, arms reaching for the sky!',
    },
    {
      time: 216,
      text: 'Land softly on your feet, bend your knees to absorb the impact!',
    },
    {
      time: 218,
      text: 'Bend your knees and squat down low, like sitting in a chair!',
    },
    {
      time: 220,
      text: 'Explode up and jump higher, push through your toes!',
    },
    {
      time: 222,
      text: 'Land softly like a ninja, keep your balance!',
    },
    {
      time: 224,
      text: 'Bend your knees and squat down low, keep your back straight!',
    },
    {
      time: 226,
      text: 'Explode up and jump to the sky, reach for the stars!',
    },
    {
      time: 228,
      text: 'Land softly on your feet, absorb the landing!',
    },
    {
      time: 230,
      text: 'Bend your knees and squat down low, keep your chest up!',
    },
    {
      time: 232,
      text: 'Explode up and jump like a rocket, maximum power!',
    },
    {
      time: 234,
      text: 'Land softly like a ninja, stay balanced!',
    },
    {
      time: 236,
      text: 'Bend your knees and squat down low, keep your form!',
    },
    {
      time: 238,
      text: 'Explode up and jump to the moon, incredible power!',
    },
    {
      time: 240,
      text: 'Land softly on your feet, great landing!',
    },
    {
      time: 242,
      text: 'Bend your knees and squat down low, keep going strong!',
    },
    {
      time: 244,
      text: 'Explode up and jump higher, you are getting stronger!',
    },
    {
      time: 246,
      text: 'Land softly like a ninja, perfect form!',
    },
    {
      time: 248,
      text: 'Bend your knees and squat down low, almost there!',
    },
    {
      time: 250,
      text: 'Explode up and jump to the stars, incredible power!',
    },
    {
      time: 252,
      text: 'Land softly on your feet, amazing jumping!',
    },
    {
      time: 254,
      text: 'Bend your knees and squat down low, last one ever!',
    },
    {
      time: 256,
      text: 'Explode up and jump your highest, finish incredibly strong!',
    },
    {
      time: 258,
      text: 'Land softly like a ninja, you are a jumping champion!',
    },
    // COMPLETION
    {
      time: 261,
      text: 'Incredible work! You just completed 40 explosive jump squats!',
    },
    {
      time: 264,
      text: 'You are building incredible leg power and jumping ability!',
    },
    {
      time: 267,
      text: 'Great job, jumping champion!',
    },
  ],
};
